import {helpers} from 'vuelidate/lib/validators'
import * as moment from 'moment';

export const customValidations = {
    update(el, binding) {
        if (binding && binding.value) {

            el.classList.add("invalid");
            el.classList;
        } else {
            el.classList.remove("invalid");
        }
    }
};

export const exactLength = (size) =>
    helpers.withParams(
        {type: 'exactLength', value: size},
        (value) => {
            if (!value) return true;
            return helpers.len(value) === size;
        }
    );

export const plate = (value,) => {
    if (!value) return true;
    const regx = RegExp('^[A-zA-Z]{3}-[0-9]{3}|^[A-aA-Z]{1}[0-9]{1}[A-zA-Z]{1}-[0-9]{3}|^[0-9]{4}-[A-zA-Z,0-9]{2}|^[A-zA-Z]{2}-[0-9]{4}$');
    return regx.test(value)
};

export const lon = (value,) => {
    if (!value) return true;
    const regx = RegExp('^(\\+|-)?(?:180(?:(?:\\.0{1,14})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,14})?))$');
    return regx.test(value)
};

export const dateGreaterThan = (date) =>
    helpers.withParams(
        {type: 'dateGreaterThan', eq: date},
        (value, parentVm) => {
            const starDate = moment(value, 'DD/MM/YYYY');
            const endDate = moment(parentVm[date], 'DD/MM/YYYY');
            if (starDate.isValid() && endDate.isValid()) {
                return starDate.isSameOrAfter(endDate)
            }
            return true;
        }
    );

export const greaterThan = (sec) =>
    helpers.withParams(
        {type: 'greaterThan', eq: sec},
        (value, parentVm) => {
            const start = value;
            const end = parentVm[sec];
            if (!isNaN(start) && !isNaN(end)) {
                return Number(start) >= Number(end)
            }
            return true;
        }
    );

export const date = (value,) => {
    if (!value) return true;
    const regx = RegExp('^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[13-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$');
    return regx.test(value)
};

export const hourGreaterThan = (hour) =>
    helpers.withParams(
        {type: 'hourGreaterThan', eq: hour},
        (value, parentVm) => {
            const startHour = Number(value ? value.replace(":", "") : '0');
            const endHour = Number(parentVm[hour] ? parentVm[hour].replace(":", "") : '0');
            return startHour >= endHour;
        }
    );


export const hour = (value,) => {
    if (!value) return true;
    const regx = RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');
    return regx.test(value)
};



// WEBPACK FOOTER //
// ./src/directives/customValidations.js